import { render, staticRenderFns } from "./EditableListItem.vue?vue&type=template&id=0ec8e4bc&"
import script from "./EditableListItem.vue?vue&type=script&lang=js&"
export * from "./EditableListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports